new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
    mounted() {
        waitForElementToExist('#faixa-cupom').then(element => {
            const faixCupom = document.querySelector('.faixa-cupom');

            if (faixCupom) {
                const formButton = document.querySelector('.faixa-cupom-form button');
                const spanElement = document.getElementById("valorParaCopiar");

                if (spanElement && formButton) {
                    let newValue = spanElement.textContent.replace(/^\/\//, '');

                    const icon = formButton.querySelector('i');
                    const originalText = formButton.textContent;

                    formButton.addEventListener("click", (e) => {
                        e.preventDefault();

                        navigator.clipboard.writeText(newValue).then(() => {

                            // altera texto mantendo o ícone
                            if (icon) {
                                formButton.innerHTML = 'Copiado!';
                            } else {
                                formButton.textContent = 'Copiado!';
                            }

                            // volta ao original após 2s
                            setTimeout(() => {
                                if (icon) {
                                    formButton.innerHTML = icon.outerHTML + ' ' + originalText.trim();
                                } else {
                                    formButton.textContent = originalText;
                                }
                            }, 2000);

                        }).catch(err => {
                            console.error('Erro ao copiar: ', err);
                        });
                    });
                }
            }
        });
    }
});

//sliders
$(document).ready(function () {
    // Funcionalidade de copiar cupom
    const copyButton = document.getElementById('copy-button');
    const cupomValue = document.getElementById('cupom-value');

    if (copyButton && cupomValue) {
        copyButton.addEventListener('click', async () => {
            try {
                const cupomText = cupomValue.textContent.trim();
                
                // Copia o texto para a área de transferência
                await navigator.clipboard.writeText(cupomText);
                
                // Salva o texto original do botão
                const originalText = copyButton.textContent;
                
                // Altera o texto do botão para mostrar que foi copiado
                copyButton.textContent = 'COPIADO!';
                copyButton.style.backgroundColor = '#28a745';
                copyButton.style.borderColor = '#28a745';
                
                // Restaura o texto original após 2 segundos
                setTimeout(() => {
                    copyButton.textContent = originalText;
                    copyButton.style.backgroundColor = '';
                    copyButton.style.borderColor = '';
                }, 2000);
                
            } catch (err) {
                // Fallback para navegadores que não suportam clipboard API
                const textArea = document.createElement('textarea');
                textArea.value = cupomValue.textContent.trim();
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
                
                // Salva o texto original do botão
                const originalText = copyButton.textContent;
                
                // Altera o texto do botão para mostrar que foi copiado
                copyButton.textContent = 'COPIADO!';
                copyButton.style.backgroundColor = '#28a745';
                copyButton.style.borderColor = '#28a745';
                
                // Restaura o texto original após 2 segundos
                setTimeout(() => {
                    copyButton.textContent = originalText;
                    copyButton.style.backgroundColor = '';
                    copyButton.style.borderColor = '';
                }, 2000);
            }
        });
    }
    
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        //fade: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    waitForElementToExist('#carousel-comunicado').then(element => {
        $('#carousel-comunicado').slick({
            arrows: true,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            delay: 2000,
            speed: 700,
    
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                    }
                }
            ]
        });
    });

    // Mini banners (carrossel no mobile, linha estatica no desktop)
    waitForElementToExist('#js_mini_banner').then(element => {
        $('#js_mini_banner').slick({
            arrows: false,
            dots: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            speed: 700,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                }
            ]
        });
    });

    // Banner de categorias (sanfona: os dois do meio maiores, os das pontas menores)
    waitForElementToExist('#js-banner-categorias').then(element => {
        const bannerCategorias = new Splide('#js-banner-categorias', {
            type: 'loop',
            perPage: 4,
            perMove: 1,
            focus: 1,
            gap: '16px',
            speed: 700,
            arrows: true,
            pagination: false,
            drag: true,
            breakpoints: {
                991: {
                    perPage: 1,
                    focus: 'center',
                    gap: '9px',
                    arrows: false,
                    pagination: true,
                }
            }
        });

        bannerCategorias.mount();
    });

    waitForElementToExist('.widget-category__content').then(element => {
        $('.widget-category__content').slick({
            arrows: true,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            delay: 2000,
            speed: 700,
    
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                }
            ]
        });
    });

    

    waitForElementToExist('.product_list').then(element => {
        $('.product_list').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
    
            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 4,
                    }
                }
            ]
        });        
    });

    waitForElementToExist('.widget-instagram__photos').then(element => {
        $('.widget-instagram__photos').slick({
            arrows: true,
            dots: false,
            infinite: true,
            autoplay: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
    
            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 5,
                    }
                }
            ]
        });
    });

    waitForElementToExist('#widget-sustainability').then(element => {
        $('#widget-sustainability').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            speed: 700,
    
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                }
            ]
        })
    });

    waitForElementToExist('.product-ratings-list').then(element => {
        $('.product-ratings-list').slick({
            arrows: true,
            dots: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
    
            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 5,
                    }
                }
            ]
        });
    });

    waitForElementToExist('.rotation-vitrine').then(element => {
        let rotationVitrine = document.querySelector('.rotation-vitrine');
        if (rotationVitrine) {
            let rotationNames = rotationVitrine.querySelectorAll('.categories .categories__name');
            let initVitrine = rotationVitrine.querySelectorAll('.rotation-vitrine__products .item');
            initVitrine = Array.from(initVitrine);
        
            if(rotationVitrine && rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');
        
                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');
                    $('#js-rotation-vitrine4, #js-rotation-vitrine3, #js-rotation-vitrine2, #js-rotation-vitrine').slick('refresh').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                        Blazy({
                            selector: '.lazy-img',
                            successClass: 'loaded-img',
                            success: function (element) {
                                setTimeout(function () {
                                    var parent = element.previousSibling;
                                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                                }, 100);
                            }
                        });
                    });
                }
        
                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    });
                })
            }
        }

        $('#js-rotation-vitrine, #js-rotation-vitrine2, #js-rotation-vitrine3, #js-rotation-vitrine4').slick({
            // mobile: sem setas, 1 card inteiro e um pedaço do próximo
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1.3,
            slidesToScroll: 1,
            speed: 700,

            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        slidesToShow: 4,
                    }
                }
            ]
        })
    });
})

function copyElementContentToClipboard(event) {
    var clipboardElement = event.currentTarget;
    var clipboardContent = clipboardElement.textContent || clipboardElement.innerText;
    
    navigator.clipboard.writeText(clipboardContent).then(function() {
        clipboardElement.classList.add("copied");
    }).catch(function(error) {
        console.error("Erro ao copiar para o clipboard:", error);
    });
}

// Adicionar o event listener ao elemento clipboard
const tcCoupon = document.getElementById("tc-coupon");
if (tcCoupon) {
    tcCoupon.addEventListener("click", copyElementContentToClipboard);
}
